<template>
    <div>
      <div class="duration__cell">
        <van-cell title="预约时长" icon=" iconfont icon-yuyue" :value="service_time+'分钟'" :border='false' />
      </div>
      <div class="date__box">
        <ul>
          <li v-for="(item,index) in date_list" :key="index" :class="{'active':date_active===index}" @click="tabClick(index)">
            <div><p>{{item.date}}</p><p class="fs_12">{{item.week}}</p></div>
            <img v-show="date_active===index" class="icon_triangle" src="/static/img/icon_triangle.png" alt="">
          </li>
        </ul>
      </div>
      <div class="timeBox">
        <ul>
          <li v-for="(item,index) in time_list" :key="index" >
            <div v-if="item.use===0"><p>{{item.time}}</p></div>
            <div :class="{'active':time_active===index}" @click="timeClick(index)" class="time__chooseItem" v-if="item.use===1"><p>{{item.time}}</p><p class="fs_12">剩余:{{item.tech_use}}</p></div>
          </li>
        </ul>
      </div>
      <div class="sureBtn__box"><a @click="check_time()">确认时间</a></div>
    </div>
</template>

<script>
import storeDetailsVue from './store/storeDetails.vue';
  export default {
    name: "selectTime",
    data(){
      return{
        service_id:0,
        store_id:0,
        tech_id:0,
        member_total:0,
        service_time:0,
        select_time:0,
        date_active:0,
        next_day:0,
        // 日期数组
        date_list:[],
        time_active:0,
        // 时间数组
        time_list:[

        ]
      }
    },
    methods: {
      //选择日期
      tabClick(index){
        this.date_active = index;
        this.get_time();
      },
      //选择时间
      timeClick(index){
        this.time_active = index
      },
      get_time(){
         this.next_day = this.date_list!=''?this.date_list[this.date_active]['date_strtotime']:0;
        this.axios({
          url: this.api.order.select_time_detail,
          data:{
            'service_id':this.service_id,
            'tech_id':this.tech_id,
            'store_id':this.store_id,
            'member_total':this.member_total,            
            'service_time':this.service_time,
            'select_time':this.select_time,
            'next_day':this.next_day,
          }
      }).then((res) => {
          if (res.error === 0) {
            this.time_list  = res.time_data
            this.date_list = res.date_arr
            this.service_time = res.service_time
            this.time_active = res.select_time_index
          }

      })
      },
      check_time(){
          var start_time = this.time_list!=''?this.time_list[this.time_active]['strtotime']:0;
          this.axios({
          url: this.api.order.select_time,
          data:{
            'service_id':this.service_id,
            'tech_id':this.tech_id,
            'store_id':this.store_id,
            'member_total':this.member_total,            
            'service_time':this.service_time,
            'start_time':start_time,
          }
      }).then((res) => {
          if (res.error === 0) {
            //修改缓存
                var order  = JSON.parse(sessionStorage.getItem("order"));
                order['select_start_time']['datetime'] = res.date_time;
                order['select_start_time']['strtotime'] = res.start_time;
                sessionStorage.setItem('order',JSON.stringify(order));
             var jump_data= {
               'service_id':this.service_id,
              'tech_id':this.tech_id,
              'store_id':this.store_id,
              'member_total':this.member_total,            
              'service_time':res.service_time,
              'start_time':res.start_time,
             }
             this.$router.push({path:'selectTech',query:jump_data});
          }

      })
      }
    },
    created(){
       this.service_id = this.$route.query.service_id;
       this.tech_id  =this.$route.query.tech_id;
       this.store_id = this.$route.query.store_id;
       this.member_total = this.$route.query.member_total;
       this.service_time = this.$route.query.service_time;
       this.select_time = this.$route.query.select_time;
       this.get_time();
    }
  }
</script>

<style scoped>
  .duration__cell{
    padding: .5rem;
  }
  .duration__cell .van-cell{
    border-radius: .15rem;
    overflow: hidden;
  }
  .van-cell__left-icon{
    color: #999;
  }
  .date__box{
    padding: 0 .5rem;
  }
  .date__box ul{
    display: flex;
    overflow-x: auto;
    color: #999;
    font-size: .7rem;
  }
  .date__box ul li{
    flex-shrink: 0;
    width: 25%;
    text-align: center;
    padding: .1rem .25rem 0;
  }
  .date__box ul li.active{
    color: #45B9BC;
  }
  .icon_triangle{
    width: 1.2rem;
    margin: .3rem auto 0;
  }
  .timeBox{
    background: #fff;
    margin: -1px .5rem .5rem;
    box-shadow: 0 1px 10px rgba(0,0,0,.1);
    border-radius: .25rem;
  }
  .timeBox ul{
    overflow: hidden;
    padding: .5rem;
  }
  .timeBox ul li{
    padding: .15rem .5rem;
    float: left;
    color: #999;
    font-size: .7rem;
    height: 2.5rem;
    width: 25%;
    display: flex;
    align-items: center;
    -webkit-align-items: center;
    justify-content: center;
    -webkit-justify-content: center;
  }
  .time__chooseItem{
    color: #45B9BC;
    width: 100%;
    height: 100%;
    text-align: center;
    padding-top: .15rem;
    border-radius: .15rem;
  }
  .time__chooseItem.active{
    background: #45B9BC;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/views/book/selectTime.vue